import { AutogenLayoutAutoMatchList } from "./autogen/AutogenLayoutAutoMatchList";
import { ClickEvent, TableRow, TableRowMode } from "@mcleod/components";
import { AutoMatchProfile } from "./AutoMatchProfile";
import { ModelRow } from "@mcleod/core";

export class AutoMatchList extends AutogenLayoutAutoMatchList {
    TableRowOnDblClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        AutoMatchProfile.showSlideout(tableRow.data, null, (row: ModelRow) => {
            this.tableAutoMatchList.rows[tableRow.index].data = row;
            this.tableAutoMatchList.rows[tableRow.index].displayComponentValues();
        });
    }

    buttonAddProfileOnClick(event: ClickEvent) {
        AutoMatchProfile.showSlideout(null, null, (row: ModelRow) => {
            this.tableAutoMatchList.addRow(row, { mode: TableRowMode.NONE }, { display: true, addToData: true });
        });
    }
}
